module.exports = __webpack_public_path__ + "b6b1c2ede45baef38768c90601544f36.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/default-owl-10.png
// module id = 553
// module chunks = 0